import { useEffect, useRef, useState } from 'react';

export const PdfPrinter = ({ pdf, onComplete }: { pdf?: string; onComplete: () => void }) => {
  const [localPdf, setLocalPdf] = useState<string>();
  const ref = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    if (pdf) {
      setLocalPdf(pdf);
      if (localPdf === pdf && ref.current) {
        ref.current.contentWindow?.print();
      }
      onComplete();
    }
  }, [pdf]);

  return (
    <div className="hidden">
      {localPdf && (
        <iframe
          ref={ref}
          src={localPdf}
          onLoad={(event) => {
            event.currentTarget.contentWindow?.print();
          }}
        />
      )}
    </div>
  );
};
